import { gql } from '@apollo/client'

export default gql`
  fragment MeetingCore on Meeting {
    id
    date
    displayDate
    status
    type
    conclusionPdfStatus
    preparationPdfStatus
    location
    duration
  }
`
